import { useEffect, useState } from "react";
import {
  fetchRecurrent,
  RecurrentResponse as RootRecurrent,
} from "services/fetch-subscription";
import { useMetadataUser } from "contexts/metadata-user-context";
import { LayoutUserData } from "./components/layout-user-data";
import { HeaderAccount } from "./components/header-account";
import { MainAccountLayout } from "./components/main-layout";
import { LayoutUserSubscription } from "./components/layout-user-subscription";
import { LayoutUserReservation } from "./components/layout-user-reservation";
import { getInfoDataCard, GetInfoDataCardResponse } from "services/get-data-card";

export const AccountBillingTemplate = () => {
  const [recurrent, setRecurrent] = useState<RootRecurrent | null>(null);
  const [infoPayment, setInfoPayment] = useState<GetInfoDataCardResponse | null>(null);
  const [activeMenuItem, setActiveMenuItem] = useState<number>(0);

  const { profile } = useMetadataUser();

  useEffect(() => {
    const fetchRecurrenData = async () => {
      try {
        if (!profile?.subscription?.recurrent_payment_id) {
          throw new Error("Recurrent ID not found");
        }

        const recurrent = await fetchRecurrent(
          profile.subscription.recurrent_payment_id
        );
        setRecurrent(recurrent);
      } catch (error) {
        setRecurrent(null);
      }
    };

    fetchRecurrenData();
  }, [profile?.subscription?.recurrent_payment_id]);

  useEffect(() => {
    const getCardDate = async () => {
      try {

        const paymentId =
          recurrent?.recurrent_payment?.recurrent_transactions[0]?.payment_id;

        if (!paymentId) {
          throw new Error("Recurrent ID not found");
        }
        const response = await getInfoDataCard(paymentId);
        setInfoPayment(response);
      } catch (error) {
        setInfoPayment(null);
      }
    };

    getCardDate();
  }, [recurrent?.recurrent_payment?.recurrent_transactions]);

  let isLoading;

  if (profile?.subscription?.recurrent_payment_id) {
    isLoading = !profile || !recurrent || !infoPayment;
  } else {
    isLoading = !profile;
  }

  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100svh-15rem)]">
        <p>Carregando...</p>
      </div>
    );
  }

  if (!profile) {
    return null;
  }

  const handleClick = (index: number) => {
    setActiveMenuItem(index);
  };

  return (
    <div className="flex flex-col px-2 md:container md:min-h-[calc(100svh-15rem)] h-full">
      <HeaderAccount
        handleClick={handleClick}
        activeMenuItem={activeMenuItem}
        profile={profile}
      />
      {activeMenuItem === 2 ? (
        <LayoutUserReservation />
      ) : (
        <MainAccountLayout>
          {activeMenuItem === 0 && <LayoutUserData profile={profile} />}
          {activeMenuItem === 1 && (
            <LayoutUserSubscription
              recurrent={recurrent}
              infoPayment={infoPayment}
              profile={profile}
            />
          )}
        </MainAccountLayout>
      )}
    </div>
  );
};
